import React from 'react';

const Loop = () => {
  return (
    <svg style={{fill: "inherit"}} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <g style={{fill: "inherit"}} transform="translate(0.217 0.662)">
        <path style={{fill: "inherit"}} d="M16.937,18a1.068,1.068,0,0,1-.769-.329l-4.924-4.926,0,0A6.907,6.907,0,0,1,7.1,14.113H7.071A7.085,7.085,0,0,1,2.044,2.051,7.04,7.04,0,0,1,6.99,0h.03a7.113,7.113,0,0,1,7.071,7.082,6.926,6.926,0,0,1-1.35,4.156l4.928,4.93A1.063,1.063,0,0,1,16.937,18ZM7,1.412a5.626,5.626,0,0,0-3.926,9.62A5.657,5.657,0,0,0,7.067,12.7h.022a5.645,5.645,0,0,0-.063-11.29Z" transform="translate(-0.217 -0.662)"/>
      </g>
    </svg>
  )
}

export default Loop;